import { useMemo } from 'react';
import { useCustomTranslation } from '../../../../../../hooks';
import { GanttShowOnTaskOption, GanttShowOnTaskOptions } from '../useProductionPlanSettings.types';
import { useProductionPlanSettings } from '../useProductionPlanSettings';
import { Chip } from '@nexelem/components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faXmark } from '@fortawesome/pro-light-svg-icons';

export const GanttShowOnTask = () => {
  const { tWrapper } = useCustomTranslation('products.productionPlan.settingDrawer');

  const setShowOnTask = useProductionPlanSettings((state) => state.setGanttShowOnTask);
  const selectedTaskOptions = useProductionPlanSettings((state) =>
    Object.entries(state.gantt.showOnTask)
      .filter(([, value]) => value)
      .map(([key]) => key as GanttShowOnTaskOption),
  );

  const showOnTaskOptions = useMemo(
    () => [
      { label: tWrapper('showOnTaskOptions.salesOrderId'), value: GanttShowOnTaskOptions.SALES_ORDER_ID },
      { label: tWrapper('showOnTaskOptions.client'), value: GanttShowOnTaskOptions.CLIENT },
      {
        label: tWrapper('showOnTaskOptions.productionOrderNumber'),
        value: GanttShowOnTaskOptions.PRODUCTION_ORDER_NUMBER,
      },
      {
        label: tWrapper('showOnTaskOptions.productionOrderExternalNumber'),
        value: GanttShowOnTaskOptions.PRODUCTION_ORDER_EXTERNAL_NUMBER,
      },
      { label: tWrapper('showOnTaskOptions.progress'), value: GanttShowOnTaskOptions.PROGRESS },
      { label: tWrapper('showOnTaskOptions.time'), value: GanttShowOnTaskOptions.TIME },
      { label: tWrapper('showOnTaskOptions.dueDate'), value: GanttShowOnTaskOptions.DUE_DATE },
      { label: tWrapper('showOnTaskOptions.assignedWorkers'), value: GanttShowOnTaskOptions.ASSIGNED_WORKERS },
    ],
    [tWrapper],
  );

  return (
    <div className="flex flex-col gap-3">
      <label className="text-t14-sb text-text-secondary">{tWrapper('showOnTask')}</label>
      <div className="flex flex-wrap gap-x-2 gap-y-3">
        {showOnTaskOptions.map(({ value, label }) => {
          const selected = selectedTaskOptions.includes(value);
          return (
            <Chip
              EndIcon={<FontAwesomeIcon icon={selected ? faCheck : faXmark} />}
              key={value}
              label={label}
              selected={selected}
              onClick={() => setShowOnTask(value)}
            />
          );
        })}
      </div>
    </div>
  );
};
